// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"6364d2a6","158":"e3ab38ef","308":"4032c970","351":"45601c34","512":"75b11a64","523":"b0913872","618":"400cc3af","828":"c14eac16","859":"3edcdb20"}[chunkId] + ".chunk.js";
};